import styled from "@emotion/styled"
import { css } from '@emotion/react'
import facepaint from "facepaint"

import { Link as GatsbyLink } from "gatsby"

const breakpoints = [768, 1024, 1200]
const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const wrapMQ = css(mq({
  borderTop: [
    "1px solid var(--color-grayscale-750)", // 0+
    "none", // 768+
    "none", // 1024+
    "none", //1200+
  ]
}))

export const Wrap = styled.footer`
  display: flex;
  align-items: center;
  background: var(--color-grayscale-950);
  ${wrapMQ}
`

const contentMQ = css(mq({
  maxWidth: [
    "calc(100vw)",
    "calc(100vw)",
    "calc(100vw)",
    "calc(100vw - 160px)"
  ],
  padding: [
    "40px",
    "40px",
    "40px",
    "72px 0 48px"
  ],
  gap: [
    "32px",
    "40px",
    "40px",
    "56px",
  ]
}))

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  width: 1280px;
  ${contentMQ}
`

const menusWrapMQ = css(mq({
  gridTemplateColumns: [
    "1fr",
    "1fr 1fr",
    "440px 220px 220px",
    "580px 290px 290px",
  ],
}))

export const MenusWrap = styled.div`
  display: grid;
  gap: 40px;
  ${menusWrapMQ}
`

const menuMQ = css(mq({
  "& a": {
    font: [
      "var(--text-340)",
      "var(--text-540)",
      "var(--text-540)",
      "var(--text-540)"
    ],
  },
}))

const noHeader = ({ noHeader }) => {
  if (noHeader) {
    return css(mq({
      marginTop: [
        0,
        0,
        50,
        50,
      ],
    }))
  }
}

export const Menu = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;
  ${noHeader}
  ${menuMQ}
`

const productMenuMQ = css(mq({
  gridTemplateColumns: [
    "1fr",
    "1fr",
    "220px 220px",
    "290px 290px",
  ],
}))

export const ProductMenu = styled.div`
  display: grid;
  gap: 16px 40px;
  ${productMenuMQ}
`

const menuHeaderMQ = css(mq({
  font: [
    "var(--text-370)",
    "var(--text-570)",
    "var(--text-570)",
    "var(--text-570)"
  ],
  marginBottom: [
    0,
    8,
    8,
    8,
  ],
}))

export const MenuHeader = styled.div`
  color: var(--color-grayscale-200);
  min-height: 26px;
  ${menuHeaderMQ}
`

const footerMQ = css(mq({
  flexDirection: [
    "column",
    "column",
    "column",
    "row"
  ],
  alignItems: [
    "start",
    "start",
    "start",
    "end"
  ],
}))

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 26px 0;
  ${footerMQ}
`

export const LogoLink = styled(GatsbyLink)`
  display: flex;
`

const socialWrapMQ = css(mq({
  order: [
    0,
    0,
    0,
    2
  ],
}))

export const SocialWrap = styled.div`
  display: flex;
  gap: 12px;
  ${socialWrapMQ}
`

const copyrightWrapMQ = css(mq({
  font: [
    "var(--text-340)",
    "var(--text-540)",
    "var(--text-540)",
    "var(--text-540)"
  ],

  "& a": {
    font: [
      "var(--text-340)",
      "var(--text-540)",
      "var(--text-540)",
      "var(--text-540)"
    ],
  },
  "& > img": {
    display: [
      "none",
      "none",
      "none",
      "flex"
    ]
  },
}))

export const CopyrightWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 18px;
  order: 1;
  ${copyrightWrapMQ}
`

export const Copyright = styled.div`
  color: var(--color-grayscale-500);
`

const copyrightDividerMQ = css(mq({
  display: [
    "none", // 0+
    "none", // 768+
    "none", // 1024+
    "block", // 1200+
  ],
}))

export const CopyrightDivider = styled.div`
  width: 1px;
  height: 16px;
  background: var(--color-grayscale-700);
  ${copyrightDividerMQ}
`

const copyrightMenuWrapMQ = css(mq({
  flexDirection: [
    "column-reverse",
    "column-reverse",
    "column-reverse",
    "row"
  ],
  alignItems: [
    "start",
    "start",
    "start",
    "center"
  ],
}))

export const CopyrightMenuWrap = styled.div`
  display: flex;
  gap: 24px 16px;
  ${copyrightMenuWrapMQ}
`

const footerMenuMQ = css(mq({
  flexDirection: [
    "column", // 0+
    "row", // 768+
    "row", // 1024+
  ],
  alignItems: [
    "start", // 0+
    "center", // 768+
    "center", // 1024+
  ],
}))

export const FooterMenu = styled.div`
  display: flex;
  gap: 12px 16px;
  flex-wrap: wrap;
  ${footerMenuMQ}
`

const footerMenuDividerMQ = css(mq({
  display: [
    "none", // 0+
    "block", // 768+
  ],
}))

export const FooterMenuDivider = styled.div`
  width: 1px;
  height: 16px;
  background: var(--color-grayscale-700);
  ${footerMenuDividerMQ}
`

const socialLinkMQ = css(mq({
  width: [
    32, // 0+
    40, // 768+
  ],
  height: [
    32, // 0+
    40, // 768+
  ],
  borderRadius: [
    8, // 0+
    12, // 768+
  ],
  "& > svg": {
    width: [
      18, // 0+
      18, // 768+
    ],
    height: [
      18, // 0+
      18, // 768+
    ],
  }
}))

export const SocialLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-white);
  background: var(--color-branding);
  transition: background var(--fast-transition);

  &:hover {
    background: rgba(250, 99, 90, 0.6);
  }
  ${socialLinkMQ}
`
